import { IValueLabel } from 'src/ts/interfaces';

export const OVERRIDE_REASON_OPTIONS: IValueLabel[] = [
  { value: '', label: 'Select a reason', isPlaceHolder: true },
  { value: '4001', label: 'Additional unsupported income sources' },
  { value: '4002', label: 'Non-Recurring income included' },
  { value: '4003', label: 'Offer letter Included' },
  { value: '4004', label: 'Income Incorrect' }
];
